import { observer } from "mobx-react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Header } from "../../components/Header";
import SizedBox from "../../components/SizedBox/SizedBox";

import {
  BUSINESS_REGISTRATION,
  PERSON_REGISTRATION,
} from "../../constants/routes";
import {
  CHOOSE_SUPERVISOR_BUSINESS,
  CHOOSE_SUPERVISOR_IF_BUSINESS,
  CHOOSE_SUPERVISOR_IF_PRIVATE,
  CHOOSE_SUPERVISOR_PRIVATE,
  CHOOSE_SUPERVISOR_WHO_ARE_YOU,
  CONTINUE_BUTTON,
} from "../../constants/translationKeys";
import translationsStore from "../../stores/TranslationsStore";
import "./ChooseSupervisorType.scss";

enum SupervisorType {
  Person = "Person",
  Business = "Business",
}

const ChooseSupervisorTypePage = () => {
  const history = useHistory();
  const [supervisorType, setSupervisorType] =
    useState<SupervisorType | null>(null);
  const { translations } = translationsStore;
  return (
    <div className="layout-column flex">
      <Header />
      <div className="page-container flex">
        <h1>Supervisor App</h1>
        <p className="choose-supervisor-type-desc">
          {translations[CHOOSE_SUPERVISOR_WHO_ARE_YOU]}
        </p>
        <div
          onClick={() => {
            setSupervisorType(SupervisorType.Person);
          }}
          className={`supervisor-type-button ${
            supervisorType === SupervisorType.Person ? "active" : ""
          }`}
        >
          {supervisorType === SupervisorType.Person ? (
            <div className="checked-icon"></div>
          ) : null}
          <h4
            className={`${
              supervisorType === SupervisorType.Person
                ? "button-text-active"
                : ""
            }`}
          >
            {translations[CHOOSE_SUPERVISOR_PRIVATE]}
          </h4>
        </div>
        <SizedBox height={5} />
        <p className="supervisor-type-desc">
          {translations[CHOOSE_SUPERVISOR_IF_PRIVATE]}
        </p>
        <div
          onClick={() => {
            setSupervisorType(SupervisorType.Business);
          }}
          className={`supervisor-type-button ${
            supervisorType === SupervisorType.Business ? "active" : ""
          }`}
        >
          {supervisorType === SupervisorType.Business ? (
            <div className="checked-icon"></div>
          ) : null}
          <h4
            className={`${
              supervisorType === SupervisorType.Business
                ? "button-text-active"
                : ""
            }`}
          >
            {translations[CHOOSE_SUPERVISOR_BUSINESS]}
          </h4>
        </div>
        <SizedBox height={5} />
        <p className="supervisor-type-desc">
          {translations[CHOOSE_SUPERVISOR_IF_BUSINESS]}
        </p>

        <div className="spacer"></div>

        <button
          disabled={!supervisorType}
          className={`button ${
            !supervisorType ? "button--state-disable" : ""
          } filled-button`}
          onClick={() => {
            if (supervisorType === SupervisorType.Person) {
              history.push(PERSON_REGISTRATION);
            } else {
              history.push(BUSINESS_REGISTRATION);
            }
          }}
        >
          {translations[CONTINUE_BUTTON]}
        </button>
      </div>
    </div>
  );
};

export default observer(ChooseSupervisorTypePage);
